(ns frontend.ui.component.image-cropper.style)

(defn react-cropper
  []
  {;; > The Cropper is styled with position: absolute to take the full space of
   ;; > its parent. Thus, you need to wrap it with an element that uses
   ;; > position: relative or the Cropper will fill the whole page.
   ;; https://github.com/ricardo-ch/react-easy-crop#basic-usage
   :position "relative"
   :height   "500px" ;; TODO
   :width    "500px"})
